export const normalizeLossPercent = (value: unknown): number | null => {
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue)) return null

  // The API field is already expressed as a percentage. Only limit its
  // precision; multiplying small values would change their meaning.
  return Math.round((numericValue + Number.EPSILON) * 100) / 100
}

export const formatLossPercent = (value: unknown): string => {
  const percentage = normalizeLossPercent(value)
  if (percentage == null) return '-'

  const formatted = percentage.toLocaleString('he-IL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).replace(/[\u200e\u200f]/g, '')

  return `${formatted}%`
}
